import { render, staticRenderFns } from "./EndPolizze.vue?vue&type=template&id=7cf62164&scoped=true"
import script from "./EndPolizze.vue?vue&type=script&lang=ts"
export * from "./EndPolizze.vue?vue&type=script&lang=ts"
import style0 from "./EndPolizze.vue?vue&type=style&index=0&id=7cf62164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf62164",
  null
  
)

export default component.exports